/**
 * Mega menu vertical tabs: L2 list on left, L3 panel on right. First tab open by default.
 */
(function () {
  function activateTab(root, activeTab) {
    const panelId = activeTab.dataset.panelId;
    if (!panelId) return;

    root.querySelectorAll('.mega-menu-tabs__tab').forEach((tab) => {
      const on = tab === activeTab;
      tab.classList.toggle('is-active', on);
      const link = tab.querySelector('.mega-menu-tabs__tab-link');
      if (link) link.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    root.querySelectorAll('.mega-menu-tabs__panel').forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === panelId);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.megaMenuTabsInit === 'true') return;
    if (window.matchMedia('(max-width: 991px)').matches) return;

    root.dataset.megaMenuTabsInit = 'true';
    const tabs = [...root.querySelectorAll('.mega-menu-tabs__tab')];
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      const link = tab.querySelector('.mega-menu-tabs__tab-link');
      const hasChildren = tab.dataset.hasChildren === 'true';

      tab.addEventListener('mouseenter', () => activateTab(root, tab));

      if (hasChildren && link) {
        link.addEventListener('click', (e) => {
          if (tab.classList.contains('is-active')) return;
          e.preventDefault();
          activateTab(root, tab);
        });
      }
    });

    const menuLi = root.closest('.header__menu_li');
    menuLi?.addEventListener('mouseenter', () => {
      if (tabs[0]) activateTab(root, tabs[0]);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mega-menu-tabs]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
